import React, { useCallback } from 'react';
import { useModalKeyTrap } from '../../hooks/useModalKeyTrap';
import '../ConfirmModal/ConfirmModal.css';

interface CuratedHintModalProps {
  title: string;
  body: string;
  closeLabel: string;
  onClose: () => void;
}

const CuratedHintModal: React.FC<CuratedHintModalProps> = ({ title, body, closeLabel, onClose }) => {
  useModalKeyTrap(useCallback(function (key, e) {
    if (key === 'Enter' || key === 'Space' || key === 'Back') {
      e.preventDefault();
      onClose();
    }
  }, [onClose]));

  return (
    <div className="confirmmodal__overlay" onClick={onClose}>
      <div className="confirmmodal__box" onClick={(e) => e.stopPropagation()}>
        <p className="confirmmodal__title">{title}</p>
        <p className="confirmmodal__desc">{body}</p>
        <div className="confirmmodal__actions">
          <button
            className="confirmmodal__btn confirmmodal__btn--focused"
            onClick={onClose}
          >
            {closeLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CuratedHintModal;
